import { css } from 'styled-components';
export default css(["p{margin:0 0 10px;}.hoursText{margin-top:25px;}"]);